var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgOtherCallIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-1167 -271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 24,
    height: 24,
    rx: 3,
    transform: "translate(1167 271)",
    fill: "#f4f4f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "store_FILL0_wght300_GRAD-25_opsz20",
    d: "M155.485-751.975v-1.178h13.491v1.178Zm.058,12.808v-5.245h-1.312v-1.178l1.254-4.656h13.491l1.254,4.656v1.178h-1.312v5.245h-1.178v-5.245H163.1v5.245Zm1.178-1.178h5.206v-4.067h-5.206Zm-1.289-5.245h0Zm0,0h13.6l-.917-3.478h-11.77Z",
    transform: "translate(1016.769 1029.161)",
    fill: "#3b3b3b"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOtherCallIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/otherCallIcon.1ccfe0be.svg";
export { ForwardRef as ReactComponent };